import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import UnitCreation from "../../components/Units/UnitCreation";


const AddUnit = () => {
  return (
    <>
 

        {/* Breadcrumb */}
        {/* <Breadcrumb title="Add Unit" /> */}
        <div className="d-flex justify-content-between"><h5>Add Unit  </h5><Breadcrumb title="Add Unit" /></div>
        {/* UsersListLayer */}

        {/* AddUserLayer */}
        <UnitCreation />


    </>
  );
};

export default AddUnit;